const ApiAttributesKeys = {
  chapterIdKey: 'chapterId',
  readingNameKey: 'name',
  readingIdKay: 'readingId',
  questionIdKey: 'id',
  questionKey: 'question',
  // Edition-stable key emitted by the backend for all CFA1 years (2026 → cfa1_2024_question_stats,
  // 2027 → cfa1_2027_question_stats are both copied into `question_stats.*`). See services/CFA/question.js.
  isAttemptedKey: 'question_stats.answer_status',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/QuestionBank/QuestionsViewList/ApiAttributesKeys.js